import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";

const DeleteuserModal = ({ open, handleClose, handleDelete }) => {

  //// console.log(open)
  return (
    <Dialog
      open={open}
      onClose={()=>{handleClose()}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete User"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this user?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{handleClose();}} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          style={{backgroundColor:"#cf2e2e",color:"white"}}
            // autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteuserModal;
